export interface CategoryItem {
  name: string;
  slug: string;
  icon: string;
  desc: string;
}

export const categories: CategoryItem[] = [
  {
    name: "社会民生",
    slug: "society",
    icon: "ri-community-line",
    desc: "公共事件、消费维权与生活相关的爆料求证。",
  },
  {
    name: "科技前沿",
    slug: "tech",
    icon: "ri-cpu-line",
    desc: "数码产品、平台规则与技术圈传言的核查。",
  },
  {
    name: "文娱动态",
    slug: "culture",
    icon: "ri-film-line",
    desc: "演出、展览、影视相关信息的真假辨析。",
  },
  {
    name: "健康生活",
    slug: "health",
    icon: "ri-heart-pulse-line",
    desc: "食品安全、健康说法与检测报告的对照解读。",
  },
  {
    name: "体育赛场",
    slug: "sports",
    icon: "ri-trophy-line",
    desc: "赛事赛程、成绩记录与赛场突发消息的核实。",
  },
];

export const sortOptions = [
  { key: "latest", label: "最新更新" },
  { key: "heat", label: "热度最高" },
  { key: "credibility", label: "可信度最高" },
] as const;

export type SortKey = (typeof sortOptions)[number]["key"];